import React from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';

import {Sort} from './sort.jsx';
import {AppRow} from './app-row.jsx';
import {LoadingRow} from './loading-row.jsx';
import {NoResults} from 'fn-common-ui';

@observer
export class SortableAppTable extends React.Component {
  static propTypes = {
    store: PropTypes.object.isRequired,
    userStore: PropTypes.object.isRequired,
    caption: PropTypes.string.isRequired,
    list: PropTypes.string.isRequired,
    columns: PropTypes.array,
    id: PropTypes.string,
    className: PropTypes.string
  };

  static defaultProps = {
    columns: [],
    id: '',
    className: ''
  }

  constructor(props) {
    super(props);
    this.store = this.props.store;
  }

  handleAppRowSelected = (e, app) => {
    if (e.key === 'Enter' || e.type === 'click') {
      this.store.appRowSelected(app);
    }
  };

  showAppsOrLoadingIndicator = () => {
    if (this.store.isLoading) {
      return [
        <LoadingRow key={1} columns={this.props.columns}/>,
        <LoadingRow key={2} columns={this.props.columns}/>
      ]
    } else if (this.store.apps[this.props.list]) {
      return this.store[this.props.list].map((app, i) => {
        return <AppRow app={app} userStore={this.props.userStore} columns={this.props.columns} key={i} onAppRowSelected={this.handleAppRowSelected}/>
      })
    }
  }

  renderNoAppsYet = () => {
    const details = `You don't have any ${this.props.list.toLowerCase()} apps.`;
    return (
      <NoResults
        title="No Results"
        text={details} />
    )
  }

  renderNoMatchingApps = () => {
    const details = `There are no ${this.props.list.toLowerCase()} apps to display. Please retry your search or reset filters.`;
    return (
      <NoResults
        title="No Results"
        text={details} />
    )
  }

  render() {
    const currentList = this.props.list;
    const currentSort = this.props.store.activeSort[currentList];
    const allAppsForList = this.store.myApps[`${this.props.list}Apps`];
    const noAppsYet = !this.store.isLoading && allAppsForList && allAppsForList.length <= 0;
    const searchResultsForList = this.store[this.props.list];
    const noMatchingApps = !this.store.isLoading && !noAppsYet && searchResultsForList && searchResultsForList.length <= 0;

    return (<div>
      <span className="sr-only" aria-live="assertive" aria-atomic="true">
        {
          `${this.props.caption} is now sorted by ${currentSort.title} in ${currentSort.direction === 'asc'
            ? 'ascending'
            : 'descending'} order.`
        }
      </span>
      <table className={`my-apps-table ${this.props.className}`} id={this.props.id}>
        <caption>
          {this.props.caption}
        </caption>
        <thead>
          <tr>
            {
              this.props.columns.map(column => {
                if(!column.property) {
                  return <th scope="col" className={`not-sortable col-${column.width}`} key={this.props.id + column.title}>
                    {column.title}
                  </th>
                } else {
                  return <th scope="col" className={`col-${column.width}`} key={this.props.id + column.title}>
                    <Sort store={this.store} property={column.property} title={column.title} list={this.props.list}>
                      {column.title}
                    </Sort>
                  </th>
                }
              })
            }
          </tr>
        </thead>
        <tbody>
          {this.showAppsOrLoadingIndicator()}
        </tbody>
      </table>
      {noAppsYet && this.renderNoAppsYet()}
      {noMatchingApps && this.renderNoMatchingApps()}
    </div>)
  }
}
